import { Info } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

// Returns a high-contrast text color (black or white) for a given hex background.
export function contrastText(hex) {
  if (!hex) return "#1C1C1C";
  let h = hex.replace("#", "");
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  const r = parseInt(h.substring(0, 2), 16);
  const g = parseInt(h.substring(2, 4), 16);
  const b = parseInt(h.substring(4, 6), 16);
  if ([r, g, b].some((v) => Number.isNaN(v))) return "#1C1C1C";
  // Perceived luminance (sRGB)
  const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return lum > 0.6 ? "#1C1C1C" : "#FFFFFF";
}

export function TagPill({ tag, className = "", testid }) {
  const bg = tag.color_hex || "#8BA888";
  const style = { backgroundColor: bg, color: contrastText(bg) };
  const base = `inline-flex items-center gap-1 px-2.5 py-0.5 rounded-full text-xs font-bold font-data ${className}`;

  if (!tag.description) {
    return (
      <span data-testid={testid} className={base} style={style}>
        {tag.name}
      </span>
    );
  }

  return (
    <Popover>
      <PopoverTrigger asChild>
        <button
          type="button"
          data-testid={testid}
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); }}
          className={`${base} cursor-pointer hover:opacity-90 transition-opacity duration-200`}
          style={style}
        >
          {tag.name}
          <Info className="h-3 w-3 opacity-80" strokeWidth={2.5} />
        </button>
      </PopoverTrigger>
      <PopoverContent
        onClick={(e) => e.stopPropagation()}
        className="w-64 rounded-sm"
        data-testid={`tag-desc-${tag.id}`}
      >
        <span className="inline-block px-2 py-0.5 rounded-full text-xs font-bold font-data mb-2" style={style}>
          {tag.name}
        </span>
        <p className="text-sm text-gray-600 leading-snug">{tag.description}</p>
      </PopoverContent>
    </Popover>
  );
}
